// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { i18n } from './services/i18n-setup'
import router from './services/router'
import VueLocalStorage from 'vue-ls'
import BootstrapVue from 'bootstrap-vue'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

window._ = require('lodash');

Vue.use(BootstrapVue);

Vue.config.productionTip = false
let vueLsOptions = {
  namespace: 'rft_configurator__'
}

Vue.filter('uppercase', function (value) {
    return value.toUpperCase()
})

Vue.use(VueLocalStorage, vueLsOptions)
/* eslint-disable no-new */

Vue.use(Toast);

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n
})





// WEBPACK FOOTER //
// ./src/main.js